const matchingFlags = {
  fr_FR: '🇫🇷',
  en_GB: '🇬🇧',
  es_ES: '🇪🇸',
  it_IT: '🇮🇹',
  de_DE: '🇩🇪'
}

export default matchingFlags
